import { KnBrDocViewerComponent } from 'src/app/common/kn-br-doc-viewer/kn-br-doc-viewer.component';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { FileUploadControl } from '@iplab/ngx-file-upload';
import { CmsService, ContentSlotData, GlobalMessageService, GlobalMessageType } from '@spartacus/core';

import { KnBrCommonService } from '../../../services/kn-br-common.service';
import { KnBrQuotesService } from '../../../store/kn-br-quotes/kn-br-quotes.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'kn-br-quote-attachment-link',
    templateUrl: './kn-br-quote-attachment-link.component.html',
    changeDetection: ChangeDetectionStrategy.Default
})
export class KnBrQuoteAttachmentLinkComponent implements OnInit {
  quote: any;
  public fileUploadControl = new FileUploadControl().setListVisibility(false).setValidators([Validators.required]);
  components: ContentSlotData;
  modalRef;
  constructor(
    protected knBrQuoteService: KnBrQuotesService,
    protected knBrCommonService: KnBrCommonService,
    protected globalMessageService: GlobalMessageService,
    protected cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private cmsService: CmsService
  ) {}

  ngOnInit(): void {
    this.knBrQuoteService.get$.subscribe((response) => {
      this.quote = response as any;
      this.cdr.markForCheck();
    });
    this.fileUploadControl.valueChanges.subscribe((value) => {
      if (value && value.length) this.onSubmit();
    });
  }

  onSubmit() {
    if (this.quote && !this.quote?.quoteAttachment) {
      const formData: FormData = new FormData();
      formData.append('attachment', this.fileUploadControl.value[0]);
      this.knBrCommonService.uploadQuoteAttachment(formData);
    } else {
      this.globalMessageService.add({ key: 'knBrMessages.removeFileFirst' }, GlobalMessageType.MSG_TYPE_WARNING);
    }
    this.fileUploadControl.clear();
  }
  removeFile() {
    this.knBrCommonService.deleteAttachment(this.quote.quoteAttachment);
  }

  isDisabled() {
    this.cmsService
      .getContentSlot('KnBrQuoteHeaderSlot')
      .subscribe((value) => (this.components = value))
      .unsubscribe();

    if (
      (this.components &&
        this.components.components &&
        this.components.components.length &&
        this.components.components[0].flexType === 'KnBrQuoteHeaderComponentReadOnly') ||
      !this.quote.editable
    ) {
      return true;
    }
    return false;
  }

  openModal() {
    let modalInstance: any;
    this.modalRef = this.modalService.open(KnBrDocViewerComponent, {
      centered: true,
      size: 'lg',
    });
    modalInstance = this.modalRef.componentInstance;
    modalInstance.url = this.quote.docURL;
    modalInstance.attachmentName = this.quote.quoteAttachment;
  }
}
